<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('sportCenter')"></TitlePage>

    <v-layout wrap>

      <v-flex md12 class="d-flex">
      <p>{{$t('dragImagesToOrder')}}</p>
      </v-flex>
      <draggable v-model="item.media" style="display: contents; cursor:pointer;">
        <v-flex md2 class="pl-4 pr-4 pb-4 mr-4" v-for="(image,index) in item.media" :key="'image'+index" style="border: 1px solid #e5e5e5;">
          <div class="text-center">
            <v-icon @click="changePosition(index,'left')" v-if="index > 0">mdi-arrow-left-thin</v-icon>
            <v-icon @click="changePosition(index,'right')" v-if="index < item.media.length-1">mdi-arrow-right-thin</v-icon>
          </div>

          <v-img :src="image" style="height: 80px" class="mb-3"></v-img>
          <v-btn color="error" x-small block @click="confirmRemove(index)">{{$t('delete')}}</v-btn>
        </v-flex>
      </draggable>

      <v-flex md12 class="d-flex">
        <UploadMediaCenter @message="addImage"></UploadMediaCenter>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import UploadMediaCenter from "@/components/admin/UploadMediaCenter";
import ModalDelete from "@/components/layout/ModalDelete.vue";
import draggable from 'vuedraggable'

export default {
  name: "EditMediaCenter",
  components: {ModalDelete, UploadMediaCenter, TitlePage, draggable},
  data() {
    return {
      item: {
        media: [],
      },
      check: true,
      errors:{},
      modalDelete: false,
      index_to_delete: -1,
      typeDelete: 'single'
    };
  },
  computed:{
    ...mapGetters({
      'getUser':'user/getUser'
    })
  },
  async created(){
    if(!this.getUser.super_admin && this.getUser.center_id != this.$route.params.id){
      this.$router.push('/')
      return
    }
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)
    this.item.media = fetchItem.result.media;
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'centers/edit',
      'updateItem':'centers/update',
    }),

    async update(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async changePosition(index, direction){
      if(direction == 'right'){
        var temp = this.item.media[index+1]
        this.item.media[index+1] = this.item.media[index]
        this.item.media[index] = temp
      }else if(direction == 'left'){
        var temp = this.item.media[index-1]
        this.item.media[index-1] = this.item.media[index]
        this.item.media[index] = temp
      }

      this.$forceUpdate();
    },

    async addImage(image){
      this.item.media.push(image)
      await this.update()
    },
    async removeHandler(mode){
      if(this.typeDelete == 'single'){
        await this.deleteImage(mode)
      }
    },
    confirmRemove(index){
      this.index_to_delete = index
      this.modalDelete = true
      this.typeDelete = 'single'
    },
    async deleteImage(image){
      if(!image){
        this.modalDelete = false
        this.index_to_delete = -1
      }else {
        this.item.media.splice(this.index_to_delete,1)
        await this.update()
        this.modalDelete = false
        this.index_to_delete = -1
      }

    },

    async checkItem(){
      this.check = true
    },

    async resetError(){
      this.errors = {}
    },

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>